import { eventEmiter, rxSideMenu, rxSections } from '../rxState';
import { API_SECTIONS } from '../../Constants';

import { api, getToken } from '../../utils/api';

export const fetchSectionsMenu = () => {
  const token = getToken()
  const request = {
    action: 'get-menu',
    token,
  };
  return api(API_SECTIONS, 'POST',request)
    .then((res) => {
      const request2 = {
        action: 'get-sections',
        token,
      };
      return api(API_SECTIONS, 'POST',request2).then( (res2) => {
        const sections = res2.sections;
        rxSections.next(sections);
        const menu = res.menu.items.map(item => {
          item.items = item.items.map(subitem => {
            if (subitem.type === 'section') {
              let foundSection;
              sections.forEach(section => {
                if (subitem.section === section._id) {
                  foundSection = section;
                }
              });
              subitem = {...subitem, ...foundSection};
            }
            return subitem;
          })
          return item;
        })
        rxSideMenu.next(menu);
      });

    })
    .catch((error) => {
      eventEmiter.next({
        type: 'add-alert',
        payload: {
          type: 'error',
          text: 'API fetch side menu error',
          description: error.message,
        },
      });
    });
};
